module.exports = __webpack_public_path__ + "img/1575147369.0c9a0fdd.jpg";